import { useEffect, useState } from 'react';
import Button from '../components/button';
import Page from '../components/page';
import main from '../main';
import { apiGetVersionInfo } from '../api';
import { showToast } from '../components/dialog';

export default function DownloadPage() {
  const [isWeixin, setIsWeixin] = useState(false);
  const [url, setUrl] = useState('');
  const [guideMask, setGuideMask] = useState(false);
  useEffect(() => {
    loadAppVersion();
  }, []);

  async function loadAppVersion() {
    let ua = (window.navigator.userAgent || '').toLowerCase();
    let _isWeixin = false;
    if (ua) {
      _isWeixin = ua.includes('micromessenger');
    }
    setIsWeixin(_isWeixin);
    if (_isWeixin) {
      return;
    }

    var isAndroid = ua.indexOf('android') > -1 || ua.indexOf('adr') > -1; //android终端

    if (isAndroid) {
      try {
        var res = await apiGetVersionInfo(isAndroid ? 'android' : 'ios');
        var data = res.data;
        if (data.code === 200) {
          setUrl(data.data.downloadPath);
        }
      } catch (e) {}
    } else {
      setUrl(main.iosDownloadUrl);
    }
  }

  function handleDownload() {
    if (isWeixin && !guideMask) {
      setGuideMask(true);
      return;
    }
    if (url) {
      window.open(url);
    } else {
      showToast('暂未发布');
    }
  }
  return (
    <Page contentClassName="d-flex-c pos-r vw-100 vh-100 overflow-hidden">
      <img className="pos-a vw-100 vh-100 z-0" src={main.pic('pic_download_bg.png')} alt="" />
      <img className="pos-a l-0 r-0 t-0 vw-100 z-1" src={main.pic('pic_download_center.png')} alt="" />
      <div className="d-flex-c ai-center mt-220 pos-r z-2">
        <div className="font-size-30">恭喜您</div>
        <div className="font-size-30">成为网上营业厅合伙人</div>
        <div className="w-250 mt-40">
          <Button type="primary" size="lg" long onClick={handleDownload}>
            下载APP
          </Button>
        </div>
        <img className="w-80 h-80 mt-40" src={main.pic('icon_logo.png')} alt="" />
        <div className="font-size-18 mt-5">网上营业厅</div>
        <div className="font-size-18 mt-20 text-color-9">应用市场搜："网上营业厅"下载APP</div>
      </div>
      {guideMask && (
        <div className="pos-a l-0 t-0 z-10 vw-100 vh-100 bg-color-3-t7" onClick={() => setGuideMask(false)}>
          <img className="bw-100" src={main.pic('pic_guide.png')} alt="" />
        </div>
      )}
    </Page>
  );
}
